import React from 'react';
import { Col, EditableInfoComponent, Row, Typography } from 'components';
import { OverviewGeneralIcon } from 'components/common/icons/OverviewGeneralIcon';

const { Text, Paragraph } = Typography;

export interface GeneralData {
  margin: string;
  discount: string;
  notes: string;
}

export const General = React.memo<{ data: GeneralData }>(({ data }) => {
  const { margin, discount, notes } = data;

  return (
    <Row>
      <Col span={24}>
        <EditableInfoComponent creatable={false} editable={false} icon={<OverviewGeneralIcon />} title={'General'} />
      </Col>
      <Col span={24}>
        {[
          ['Margin', margin ? `${margin}%` : null],
          ['Discount', discount ? `${discount}%` : null],
        ].map(([label, value]) => (
          <Row justify="space-between" key={label} align={'middle'} gutter={[0, 4]}>
            <Col>
              <Text type={'secondary'} className={'font-size-16'}>
                {label}
              </Text>
            </Col>
            <Col flex="0 1 auto">
              <Text
                type={'secondary'}
                className={'font-size-16'}
                style={{ whiteSpace: 'nowrap' }}
                ellipsis={{ tooltip: true }}
              >
                {value || 'Not Set'}
              </Text>
            </Col>
          </Row>
        ))}
        {notes && (
          <Col span={24}>
            <Paragraph
              type={'secondary'}
              className={'font-size-16'}
              ellipsis={{
                rows: 6,
                expandable: false,
                tooltip: true,
              }}
            >
              <strong>Notes:</strong> {notes}
            </Paragraph>
          </Col>
        )}
      </Col>
    </Row>
  );
});
